import { convertToAmount } from 'utils/helpers';
import { Deal, Meta } from 'utils/types';

const sortDeals = (deals: Deal[]) =>
  deals?.reduce(
    (obj, item) => {
      const { stageId, amount, ...rest } = item;
      if (!obj[stageId as string]) {
        obj[stageId as string] = [];
      }
      obj[stageId as string].push({
        ...rest,
        amount,
        stageId,
        _amount: convertToAmount(amount),
      });

      obj[stageId as string] = obj[stageId as string].sort(
        (a: Deal, b: Deal) => a.sequence - b.sequence,
      );

      return obj;
    },
    {} as Record<string, any>,
  );

const dealsBoard = ({ data, meta }: { data: Deal[]; meta: Meta }) => ({
  meta,
  data: sortDeals(data),
});

const dealsList = ({ data, meta }: { data: Deal[]; meta: Meta }) => ({
  meta,
  data: data?.map(({ amount, ...rest }) => ({
    ...rest,
    amount,
    _amount: convertToAmount(amount),
  })),
});

export default { dealsBoard, dealsList };
